export function productCapacityMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      productCapacityId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateProductCapacityId(json) {
  return {
    data: {...json, id: json.objectId},
  };
}

export function fixCreateProductCapacityId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function fixGetManyProductCapacity(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      productCapacityId: resource.objectId,
    })),
  };
}

export function productCapacityMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, productCapacityId: json.result.objectId},
  };
}